import React from 'react'
import s from './IconTextList.module.css'

export interface IListForm {
  _key?: string
  icon?: string
  content?: string
}

export interface IconTextListProps {
  list?: Array<IListForm>
  title?: string,
  subtitle?: string
}

const IconTextList: React.FC<IconTextListProps> = ((props) => {
  const {
    list,
    title,
    subtitle
  } = props

  return (
    <div className={s.root}>
      <div className={s.content}>
        <div className={s.inner}>
          <div className={s.textCover}>
            <h3 className={`text-heading02Mobile md:text-heading01Mobile ${s.title}`}>{title}
              <span className={s.subtitle}>{subtitle}</span>
            </h3>
          </div>
          <div className="md:mx-auto md:max-w-6xl md:px-6 md:mx-0 md:px-0 md:flex-1">
            <ul className={s.list}>
              {list?.map((item, index) => {
                const key = item?._key ?? `item-${index}`
                return (
                  <li className={s.item} key={key}>
                    <span className={`${s.icon} text-neutral700 text-icon22 ${item.icon ?? ''}`} />
                    <div className={s.itemListText}>{String(item.content ?? '')}</div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
})

export default IconTextList
